export const NEVER_INSTALLED_VIEW_MODE = 'neverInstalled';
export const INSTALL_ISSUE_VIEW_MODE = 'installIssue';
export const VERIFIED_VIEW_MODE = 'verified';

const VIEW_MODES = [
    NEVER_INSTALLED_VIEW_MODE,
    INSTALL_ISSUE_VIEW_MODE,
    VERIFIED_VIEW_MODE,
] as const;

export type FlowPreviewModalViewMode = (typeof VIEW_MODES)[number];
